export const REQUEST = 'PROJECT_DASHBOARD_REQUEST';
export const GET_PROJECT_SUCCESS = 'PROJECT_DASHBOARD_GET_PROJECT_SUCCESS';
export const GET_PROJECT_FAILURE = 'PROJECT_DASHBOARD_GET_PROJECT_FAILURE';